import React from "react";
import ReactDOM from "react-dom/client";
import DefenceReadinessAuditGaps from "./defence-readiness-audit-gaps";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <DefenceReadinessAuditGaps />
  </React.StrictMode>,
);
